import script from "./TableControlItem.vue?vue&type=script&setup=true&lang=ts"
export * from "./TableControlItem.vue?vue&type=script&setup=true&lang=ts"

import "./TableControlItem.vue?vue&type=style&index=0&id=1804dbd8&lang=css"

const __exports__ = script;

export default __exports__